import React from "react"

// Instagram captions often end in a long run of hashtags appended directly
// to the sentence (e.g. "...must see this. #VRFS #MetaQuest #VRGaming...").
// Rendered verbatim in the same bold heading style as the rest of the
// caption, that tail reads as a wall of shouted hashtags - this splits the
// string on hashtag tokens and renders just those in the lighter, smaller
// hashtag color already used elsewhere in the UI, while the caption's actual
// words keep their normal weight. A title that isn't a caption at all (this
// app's own "Instagram Reel by @username" fallback when there's no caption)
// has no hashtags to split, so it renders unchanged either way.
const HASHTAG_RE = /(#[\p{L}\p{N}_]+)/gu

const CaptionText = ({ text }) => {
  if (!text) return null
  const parts = text.split(HASHTAG_RE)
  // split() with one capturing group alternates [text, hashtag, text, hashtag, ...] -
  // odd indices are always the captured hashtag tokens.
  return parts.map((part, i) =>
    i % 2 === 1
      ? <span key={i} style={{ color: "#8b9bd1", fontWeight: 500 }}>{part}</span>
      : part
  )
}

export default CaptionText
